export default __webpack_public_path__ + "static/media/success-card-upload.b0d184ec.png";